// extracted by mini-css-extract-plugin
module.exports = {"activateContainer":"styles_activateContainer__3zWkE","activateHeader":"styles_activateHeader__2IRya","formMessages":"styles_formMessages__1Kpxc"};